// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1zbr1","info":"Note_info__LL9ml","note":"Note_note__aT_1S","actions":"Note_actions__1PB0x"};